import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Clubs from "./clubs";
import ClubDetails from "./clubDetails";
import { triggerMobileAppOrStoreRedirect } from "../utils/openAppRedirect";

const OBJECT_ID_RE = /^[a-f\d]{24}$/i;

/** /clubs/mumbai → list; /clubs/{objectId} → club details */
const ClubsOrDetails = () => {
  const { city } = useParams();

  useEffect(() => {
    if (OBJECT_ID_RE.test(city || "")) {
      triggerMobileAppOrStoreRedirect({ entityType: "clubs", entityId: city });
    }
  }, [city]);

  if (OBJECT_ID_RE.test(city || "")) {
    return <ClubDetails />;
  }

  return <Clubs />;
};

export default ClubsOrDetails;
